let API_DOMAIN = null;
let EVENT_ID = null;

let players = [];
let currentWinner = null;
let spinning = false;

// --- Match new project IDs ---
const drawButton = document.getElementById("drawButton");
const spinnerContainer = document.querySelector(".spinner-container");
const placeholderText = spinnerContainer?.querySelector(".placeholder");
const modal = document.getElementById("modal");
const modalCloseButton = document.getElementById("modalCloseButton");
const modalAssignButton = document.getElementById("modalAssignButton");
const modalWinnerName = document.getElementById("winnerName");
const loadingScreen = document.getElementById("loadingScreen");

// --- Utility ---
function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

// The API returns status as a comma-separated list of the codes that are
// currently active, e.g. "1,2,4" — several pages can be open at the same time.
function isStatusActive(status, code) {
  return String(status ?? "")
    .split(",")
    .map((s) => s.trim())
    .includes(code);
}

function showLoading(show) {
  if (!loadingScreen) return;
  if (show) {
    loadingScreen.classList.remove("hidden");
  } else {
    loadingScreen.classList.add("hidden");
  }
}

// --- Load Config ---
async function loadConfig() {
  const res = await fetch("./config.json"); // adjust path as needed
  if (!res.ok) {
    throw new Error(`Failed to load config.json: ${res.status}`);
  }
  const config = await res.json();
  API_DOMAIN = config.apiDomain;
}

// --- Check Event Status ---
async function checkEventStatus() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/event/list`);
    const data = await res.json();
    await sleep(500); // 0.5s visible minimum for loading animation

    if (data.message === "success" && Array.isArray(data.data) && data.data.length > 0) {
      const event = data.data[0];
      EVENT_ID = event.id;
      if (isStatusActive(event.status, "2")) {
        await loadParticipants();
      } else {
        window.location.href = "eventClosed.html";
      }
    } else {
      window.location.href = "eventClosed.html";
    }
  } catch (err) {
    console.error("Error checking event:", err);
    window.location.href = "eventClosed.html";
  } finally {
    showLoading(false);
  }
}

// --- Load Participants ---
async function loadParticipants() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/internal/battle/participants`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventId: EVENT_ID }),
    });
    const result = await res.json();
    await sleep(300);

    if (result.message === "success" && result.data?.available) {
      players = result.data.available.map((p) => p.ticketId);
      console.log("Available participants:", players);
      drawButton.disabled = players.length === 0;
    } else {
      drawButton.disabled = true;
      console.warn("No participants found.");
    }
  } catch (err) {
    console.error("Error loading participants:", err);
    drawButton.disabled = true;
  } finally {
    showLoading(false);
    if (placeholderText) {
      placeholderText.textContent = "Who's in for the battle?";
    }
  }
}

// --- Draw Button Click ---
drawButton?.addEventListener("click", async () => {
  if (spinning || players.length === 0) return;
  spinning = true;
  drawButton.disabled = true;

  if (placeholderText) placeholderText.textContent = "";

  spinnerContainer.style.position = "relative";
  spinnerContainer.style.overflow = "hidden";
  spinnerContainer.style.display = "block";

  // Create scrolling list
  spinnerContainer.innerHTML = `
    <div class="scroll-list" style="
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 62px;
      line-height: 100px;
      font-weight: 900;
      color: #fff;
      transform: translateY(0);
    ">
      ${players.map((p) => `<div>${p}</div>`).join("")}
    </div>
  `;

  const listEl = spinnerContainer.querySelector(".scroll-list");
  const itemHeight = 100;
  const totalRounds = 8;
  const spinDuration = 4.5;
  const randomIndex = Math.floor(Math.random() * players.length);

  // offset ensures list starts centered vertically inside capsule
  const containerHeight = spinnerContainer.offsetHeight;
  const centerOffset = containerHeight / 2 - itemHeight / 2;
  listEl.style.top = `${centerOffset}px`;

  // extend list
  const extendedList = [];
  for (let i = 0; i < totalRounds + 2; i++) extendedList.push(...players);
  listEl.innerHTML = extendedList.map((p) => `<div>${p}</div>`).join("");

  const finalOffset = (players.length * totalRounds + randomIndex) * itemHeight;

  // force reflow before animation
  listEl.offsetHeight;

  // animate scroll
  requestAnimationFrame(() => {
    listEl.style.transition = `transform ${spinDuration}s cubic-bezier(0.05, 0.9, 0.25, 1)`;
    listEl.style.transform = `translateY(-${finalOffset}px)`;
  });

  await new Promise((r) => setTimeout(r, spinDuration * 1000 + 300));

  // --- Winner ---
  currentWinner = players[randomIndex];
  modalWinnerName.textContent = currentWinner;
  showModal();

  // Reset to show only winner name centered
  listEl.style.transition = "none";
  listEl.style.transform = "translateY(0)";
  listEl.innerHTML = `
    <div style="
      font-size: 62px;
      font-weight: 900;
      color: #fff;
      line-height: 100px;
      text-align: center;
    ">${currentWinner}</div>
  `;

  spinnerContainer.style.display = "flex";
  spinnerContainer.style.alignItems = "center";
  spinnerContainer.style.justifyContent = "center";

  spinning = false;
  drawButton.disabled = false;
});

// --- Popup Logic ---
function showModal() {
  if (!modal) return;
  modal.classList.add("active");
}

function hideModal() {
  if (!modal) return;
  modal.classList.remove("active");
}

modalCloseButton?.addEventListener("click", async () => {
  await sendWinStatus(0);
});

modalAssignButton?.addEventListener("click", async () => {
  await sendWinStatus(1);
});

async function sendWinStatus(winValue) {
  try {
    await fetch(`${API_DOMAIN}api/internal/battle/win`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        eventId: EVENT_ID,
        ticketId: currentWinner,
        win: winValue,
      }),
    });
  } catch (err) {
    console.error("Error sending win status:", err);
  } finally {
    hideModal();
    await loadParticipants();
  }
}

// --- Init ---
document.addEventListener("DOMContentLoaded", async () => {
  showLoading(true);
  await sleep(300);

  try {
    await loadConfig();       // 🔹 load API_DOMAIN before anything else
    await checkEventStatus();
  } catch (err) {
    console.error("Error loading config:", err);
    window.location.href = "eventClosed.html";
  }
});